import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      skills: 'Skills',
      projects: 'Projects',
      experience: 'Experience',
      education: 'Education',
      contact: 'Contact'
    },
    hero: {
      greeting: 'Hello, I\'m',
      name: 'Karona Srun',
      title: 'Full Stack Developer',
      description: 'I create digital experiences that bridge technology and human connection. Passionate about building scalable web applications and innovative solutions.',
      cta: 'Get In Touch',
      downloadCV: 'Download CV'
    },
    about: {
      title: 'About Me',
      description: 'I\'m a passionate Full Stack Developer with expertise in modern web technologies. I love creating efficient, scalable, and user-friendly applications that solve real-world problems.',
      background: 'Background',
      backgroundText: 'With years of experience in web development, I specialize in JavaScript ecosystem, including Vue.js, React, Node.js, and various databases. I\'m always eager to learn new technologies and improve my skills.',
      interests: 'Interests',
      interestsText: 'When I\'m not coding, I enjoy exploring new technologies, reading tech blogs, and contributing to open-source projects. I also love photography and traveling.'
    },
    skills: {
      title: 'Skills & Technologies',
      frontend: 'Frontend',
      backend: 'Backend',
      devops: 'DevOps & Tools',
      databases: 'Databases'
    },
    projects: {
      title: 'Featured Projects',
      viewDemo: 'View Demo',
      viewCode: 'View Code',
      allProjects: 'All',
      filterBy: 'Filter by technology'
    },
    experience: {
      title: 'Work Experience',
      present: 'Present'
    },
    education: {
      title: 'Education',
      degree: 'Degree',
      institution: 'Institution',
      year: 'Year'
    },
    contact: {
      title: 'Get In Touch',
      subtitle: 'Let\'s discuss your next project',
      name: 'Your Name',
      email: 'Your Email',
      message: 'Your Message',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully!',
      error: 'Failed to send message. Please try again.',
      info: 'Contact Information',
      location: 'Phnom Penh, Cambodia'
    },
    footer: {
      rights: 'All rights reserved.',
      madeWith: 'Made with',
      in: 'in Cambodia'
    },
    common: {
      loading: 'Loading...',
      error: 'Something went wrong',
      retry: 'Try Again'
    }
  },
  km: {
    nav: {
      home: 'ទំព័រដើម',
      about: 'អំពីខ្ញុំ',
      skills: 'ជំនាញ',
      projects: 'គម្រោង',
      experience: 'បទពិសោធន៍',
      education: 'ការអប់រំ',
      contact: 'ទំនាក់ទំនង'
    },
    hero: {
      greeting: 'សួស្ដី ខ្ញុំឈ្មោះ',
      name: 'ស្រ៊ុន​ ករណា',
      title: 'អ្នកអភិវឌ្ឍន៍វេបសាយ',
      description: 'ខ្ញុំបង្កើតបទពិសោធន៍ឌីជីថលដែលភ្ជាប់បច្ចេកវិទ្យានិងការតភ្ជាប់របស់មនុស្ស។ ចាប់អារម្មណ៍ក្នុងការបង្កើតកម្មវិធីគេហទំព័រដែលអាចពង្រីកបាននិងដំណោះស្រាយច្នៃប្រឌិត។',
      cta: 'ទាក់ទងមកខ្ញុំ',
      downloadCV: 'ទាញយកប្រវត្តិរូប'
    },
    about: {
      title: 'អំពីខ្ញុំ',
      description: 'ខ្ញុំជាអ្នកអភិវឌ្ឍន៍វេបសាយដែលមានចំណង់ចំណូលចិត្តជាមួយនឹងជំនាញក្នុងបច្ចេកវិទ្យាវេបសម័យ។ ខ្ញុំចូលចិត្តបង្កើតកម្មវិធីដែលមានប្រសិទ្ធភាព អាចពង្រីកបាន និងងាយស្រួលប្រើសម្រាប់អ្នកប្រើប្រាស់។',
      background: 'ប្រវត្តិ',
      backgroundText: 'ជាមួយនឹងបទពិសោធន៍ជាច្រើនឆ្នាំក្នុងការអភិវឌ្ឍន៍វេបសាយ ខ្ញុំមានជំនាញខាងបរិស្ថាន JavaScript រួមទាំង Vue.js, React, Node.js និងមូលដ្ឋានទិន្នន័យផ្សេងៗ។ ខ្ញុំតែងតែចង់រៀនបច្ចេកវិទ្យាថ្មីនិងកែលម្អជំនាញរបស់ខ្ញុំ។',
      interests: 'ចំណាប់អារម្មណ៍',
      interestsText: 'នៅពេលដែលខ្ញុំមិនកំពុងសរសេរកូដ ខ្ញុំចូលចិត្តស្វែងយល់បច្ចេកវិទ្យាថ្មី អានប្លុកបច្ចេកវិទ្យា និងចូលរួមចំណែកដល់គម្រោងកូដបើកចំហ។ ខ្ញុំក៏ចូលចិត្តថតរូបនិងដំណើរផងដែរ។'
    },
    skills: {
      title: 'ជំនាញ និងបច្ចេកវិទ្យា',
      frontend: 'ផ្នែកខាងមុខ',
      backend: 'ផ្នែកខាងក្រោយ',
      devops: 'DevOps និងឧបករណ៍',
      databases: 'មូលដ្ឋានទិន្នន័យ'
    },
    projects: {
      title: 'គម្រោងសំខាន់ៗ',
      viewDemo: 'មើលសាកល្បង',
      viewCode: 'មើលកូដ',
      allProjects: 'ទាំងអស់',
      filterBy: 'ត្រងតាមបច្ចេកវិទ្យា'
    },
    experience: {
      title: 'បទពិសោធន៍ការងារ',
      present: 'បច្ចុប្បន្ន'
    },
    education: {
      title: 'ការអប់រំ',
      degree: 'កម្រិតសិក្សា',
      institution: 'គ្រឹះស្ថានសិក្សា',
      year: 'ឆ្នាំ'
    },
    contact: {
      title: 'ទាក់ទងមកខ្ញុំ',
      subtitle: 'សូមពិភាក្សាអំពីគម្រោងបន្ទាប់របស់អ្នក',
      name: 'ឈ្មោះរបស់អ្នក',
      email: 'អ៊ីមែលរបស់អ្នក',
      message: 'សាររបស់អ្នក',
      send: 'ផ្ញើសារ',
      sending: 'កំពុងផ្ញើ...',
      success: 'សារត្រូវបានផ្ញើដោយជោគជ័យ!',
      error: 'មិនអាចផ្ញើសារបានទេ។ សូមព្យាយាមម្តងទៀត។',
      info: 'ព័ត៌មានទំនាក់ទំនង',
      location: 'ភ្នំពេញ កម្ពុជា'
    },
    footer: {
      rights: 'រក្សាសិទ្ធិទាំងអស់។',
      madeWith: 'បង្កើតដោយ',
      in: 'នៅកម្ពុជា'
    },
    common: {
      loading: 'កំពុងផ្ទុក...',
      error: 'មានបញ្ហាកើតឡើង',
      retry: 'ព្យាយាមម្តងទៀត'
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('language') || 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n 